import { createContext, Dispatch, SetStateAction } from 'react'

import { CostCenter, CostCenterFilterKeyString } from 'InstitutionalManagement/types'

type CustomFormCostCenterSelectionDrawerManagerContextType = {
  view: string
  setView: Dispatch<SetStateAction<string>>
  selectedCostCenter: CostCenter
  setSelectedCostCenter: (newCostCenter: CostCenter) => void
  filter: CostCenterFilterKeyString
  setFilter: Dispatch<SetStateAction<CostCenterFilterKeyString>>
  questionKey: string
  costCenters: CostCenter[]
  loadingCostCenters: boolean
  setLoadingCostCenters: Dispatch<SetStateAction<boolean>>
}

const defaultValue = {
  view: '',
  setView: () => {},
  selectedCostCenter: {},
  setSelectedCostCenter: () => {},
  filter: {},
  setFilter: () => {},
  questionKey: '',
  costCenters: [],
  loadingCostCenters: false,
  setLoadingCostCenters: () => {},
}

const CustomFormCostCenterSelectionDrawerManagerContext =
  createContext<CustomFormCostCenterSelectionDrawerManagerContextType>(defaultValue)

export default CustomFormCostCenterSelectionDrawerManagerContext
